import React from 'react';

import { useAnimateInRef } from '../../../utils/hooks';

import * as styles from './Location.module.scss';

interface LocationProps {
  location: string;
  onClick: () => void;
}

const Location = ({ location, onClick }: LocationProps): React.ReactElement => {
  return (
    <section className={styles.location} onClick={onClick}>
      <span
        ref={useAnimateInRef(styles.animateIn, 600)}
        className={styles.icon + ' ' + styles.locationIcon}
      >
        <svg
          enableBackground="new 0 0 24 24"
          height="24px"
          id="location"
          version="1.1"
          viewBox="0 0 24 24"
          width="24px"
        >
          <path d="M11.513,12.38c-2.117,0-3.835-1.729-3.835-3.862c0-2.135,1.718-3.863,3.835-3.863s3.835,1.729,3.835,3.863  C15.348,10.65,13.63,12.38,11.513,12.38 M11.513,0C6.825,0,3.025,3.827,3.025,8.549c0,4.46,3.844,10.213,6.411,13.014  c0.959,1.045,2.076,2.454,2.076,2.454s1.2-1.417,2.229-2.493C16.306,18.84,20,13.451,20,8.549C20,3.827,16.2,0,11.513,0" />
        </svg>
      </span>
      <span ref={useAnimateInRef(styles.animateIn, 700)} className={styles.text}>
        {location}
      </span>
      <span
        ref={useAnimateInRef(styles.animateIn, 800)}
        className={styles.icon + ' ' + styles.carretIcon}
      >
        <svg
          enableBackground="new 0 0 292.362 292.362"
          height="24px"
          id="carret-down"
          version="1.1"
          viewBox="0 0 292.362 292.362"
          width="24px"
        >
          <path
            d="M286.935,69.377c-3.614-3.617-7.898-5.424-12.848-5.424H18.274c-4.952,0-9.233,1.807-12.85,5.424
		C1.807,72.998,0,77.279,0,82.228c0,4.948,1.807,9.229,5.424,12.847l127.907,127.907c3.621,3.617,7.902,5.428,12.85,5.428
		s9.233-1.811,12.847-5.428L286.935,95.074c3.613-3.617,5.427-7.898,5.427-12.847C292.362,77.279,290.548,72.998,286.935,69.377z"
          />
        </svg>
      </span>
    </section>
  );
};

export default Location;
